export enum TeamJobAddressSelectionType {
    FarmAddress = 0,
    DropPin = 1,
    CustomAddress = 2,
}